import { makeActionCreator } from '../../../../../utilities'
import { ObstetricsConstants } from './obstetrics.constants'

export const setIsPatientPregnant = makeActionCreator(ObstetricsConstants.SET_IS_PATIENT_PREGNANT, 'isPatientPregnant')
export const setIsPatientPregnantPNNV = makeActionCreator(
  ObstetricsConstants.SET_IS_PATIENT_PREGNANT_PNNV,
  'isPatientPregnantPNNV'
)
export const setGravida = makeActionCreator(ObstetricsConstants.SET_GRAVIDA, 'gravida')
export const setPara = makeActionCreator(ObstetricsConstants.SET_PARA, 'para')
export const setGestationAgeWeeks = makeActionCreator(
  ObstetricsConstants.SET_GESTATIONAL_AGE_WEEKS,
  'gestationAgeWeeks'
)
export const setGestationAgeDays = makeActionCreator(ObstetricsConstants.SET_GESTATIONAL_AGE_DAYS, 'gestationAgeDays')
export const setExpectedDateOfConfinement = makeActionCreator(
  ObstetricsConstants.SET_EXPECTED_DATE_OF_CONFINEMENT,
  'expectedDateOfConfinement'
)
export const setLastMenstrualPeriod = makeActionCreator(
  ObstetricsConstants.SET_LAST_MENSTRUAL_PERIOD,
  'lastMenstrualPeriod'
)
export const setInitialFetalHeartRate = makeActionCreator(
  ObstetricsConstants.SET_INITIAL_FETAL_HEART_RATE,
  'initialFetalHeartRate'
)
export const setContractionsFreq = makeActionCreator(ObstetricsConstants.SET_CONTRACTIONS_FREQUENCY, 'contractionsFreq')
export const setContractionsDur = makeActionCreator(ObstetricsConstants.SET_CONTRACTIONS_DURATION, 'contractionsDur')
export const setMembranes = makeActionCreator(ObstetricsConstants.SET_MEMBRANES_AMNIOTIC_FLUID, 'membranes')
export const setRuptureTime = makeActionCreator(ObstetricsConstants.SET_RUPTURE_TIME, 'ruptureTime')
export const setDilation = makeActionCreator(ObstetricsConstants.SET_DILATION, 'dilation')
export const setEffacement = makeActionCreator(ObstetricsConstants.SET_EFFACEMENT, 'effacement')
export const setMaternalMedicationsAdministered = makeActionCreator(
  ObstetricsConstants.SET_MATERNAL_MEDICATIONS_ADMINISTERED,
  'maternalMedicationsAdministered'
)
export const setPresentingPart = makeActionCreator(ObstetricsConstants.SET_PRESENTING_PART, 'presentingPart')
export const setBloodyShow = makeActionCreator(ObstetricsConstants.SET_BLOODY_SHOW, 'bloodyShow')
export const setPrenatalCare = makeActionCreator(ObstetricsConstants.SET_PRENATAL_CARE, 'prenatalCare')
export const setComments = makeActionCreator(ObstetricsConstants.SET_COMMENTS, 'comments')

export const setObstetrics = makeActionCreator(ObstetricsConstants.SET_OBSTETRICS, 'obstetrics')
export const resetObstetrics = makeActionCreator(ObstetricsConstants.RESET_OBSTETRICS)
export const saveObstetrics = makeActionCreator(ObstetricsConstants.SAVE_OBSTETRICS)
